module.exports = __webpack_public_path__ + "img/map.66913221.png";